import { ReactNode } from "react";

export enum TabsVariants {
  Pill = "pill",
  Squared = "squared",
}

export interface TabProps {
  id: string;
  header: ReactNode;
  subHeader?: ReactNode;
  body: ReactNode;
}
